import clsx from 'clsx'

export const buttonStyles: {
  base: string
  type: { [key: string]: string }
  size: { [key: string]: string }
  inverted: { [key: string]: string }
} = {
  base: 'btn font-bold text-bodyL leading-sm font-poppins transition duration-200 overflow-hidden',
  type: {
    primary: 'bg-primary-500 text-white hover:bg-primary-900 focus:bg-primary-900 focus-within:bg-primary-900',
    secondary:
      'bg-transparent text-text-brand-darker shadow-button-secondary hover:bg-primary-900 hover:text-white hover:shadow-button-secondary-hover focus:bg-primary-900 focus:text-white focus:shadow-button-secondary-hover focus-within:bg-primary-900 focus-within:text-white focus-within:shadow-button-secondary-hover',
    tertiary:
      'text-text-dark-900 hover:text-text-brand-darker focus:text-text-brand-darker focus-within:text-text-brand-darker',
    'secondary-inverted':
      'bg-transparent text-white shadow-button-secondary-inverted hover:bg-primary-900 hover:text-white hover:shadow-button-secondary-hover focus:bg-primary-900 focus:text-white focus:shadow-button-secondary-hover focus-within:bg-primary-900 focus-within:text-white focus-within:shadow-button-secondary-hover',
    'tertiary-inverted': 'text-white hover:text-text-white-80 focus:text-text-white-80 focus-within:text-text-white-80'
  },
  size: {
    large: 'px-24 py-16 rounded',
    small: 'px-24 py-12 rounded'
  },
  inverted: {
    primary:
      'bg-white text-text-brand-darker hover:bg-primary-900 hover:text-white focus:bg-primary-900 focus:text-white focus-within:bg-primary-900 focus-within:text-white',
    secondary:
      'bg-transparent text-text-brand-darker hover:bg-primary-900 hover:text-white focus:bg-primary-900 focus:text-white focus-within:bg-primary-900 focus-within:text-white'
  }
}

export function getButtonStyle(buttonVariant: ButtonTypes['variant'], className?: string, cmsClass?: string[]) {
  if (!buttonVariant) return ''
  const [version, size, inverted] = buttonVariant.split('-')

  const { base } = buttonStyles
  const typeKey = inverted ? `${version}-inverted` : version
  const typeStyle: string = buttonStyles.type[typeKey] || ''
  const sizeStyle: string = buttonStyles.size[size] || ''
  const invertedStyle: string = inverted ? buttonStyles.inverted[version] : ''

  return clsx(base, typeStyle, sizeStyle, invertedStyle, className, cmsClass)
}
